import { defineStore } from "pinia"
import api from "@/api/ticket_priority"

export const useTicketPriority = defineStore("ticketPriority", {
    state: () => ({
        allDict: {
            // example_id: { name: "example_name", _id: "example_id", colour: "#A3F2B1" },
        }
    }),
    getters: {
        getById: (state) => (id) => state.allDict[id],
        allArray: (state) => Object.values(state.allDict),
        dropdownOptions: (state) => Object.values(state.allDict).map((p) => ({
            ...p,
            text: p.name,
            value: p._id,
        }))
    },
    actions: {
        _updateDict(id, data) {
            this.allDict[id] = data
        },
        _delFromDict(id) {
            delete this.allDict[id]
        },
        async load(organizationId) {
            const ticketPriorities = await api.fetchAll(organizationId)
            ticketPriorities.forEach(ticketPriority => {
                this._updateDict(ticketPriority._id, ticketPriority)
            })
        },
        async create(name, colour, icon, notes, organizationId) {
            const ticketPriority = await api.create(name, colour, icon, notes, organizationId)
            this._updateDict(ticketPriority._id, ticketPriority)
        },
        async update(id, name = null, colour = null, icon = null, notes = null) {
            const ticketPriority = await api.update(id, name, colour, icon, notes)
            this._updateDict(ticketPriority._id, ticketPriority)
        },
        async del(id) {
            const deletedId = await api.del(id)
            this._delFromDict(deletedId)
        }
    }
})